import * as H from 'history';
import { Paths } from '../../../common/enums/Paths';
import { DeepLinkType } from '../../../service/DeepLinkManager/IDeepLinkManager';
import { isEntryMenuEnabled } from '../../../utilities/ECSConfigUtils';
import { getAppHost } from '../../../utilities/TeamsUtils';

export const mobileOnCreateSuccess = (history: H.History<H.LocationState>): void => {
    if (getAppHost().getDeepLinkManager().getDeepLinkType() === DeepLinkType.vivaConnectionsNewApproval) {
        history.push(Paths.BasePath + Paths.ApprovalsApp);
    } else if (isEntryMenuEnabled()) {
        // when create a basic approval on mobile successfully, go back twice.
        // because if we go back once we back to mobile create request menu view
        // we use history.goback here instead of history.push to jump to personal app directly is
        // because that goback will retain status of personal app like previous
        // chosen tab(receive/send)
        history.go(-2);
    } else {
        history.goBack();
    }
};
